<template>
    <div v-if="have_data == false">
        <section class="section section-shaped section-md my-0 section-header-pages single-region">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="d-flex  align-items-end data-head-single" style="height: 100%;">
                                <div class="flex-column">
                                    <h2 class="display-2 mb-0 text-white">{{ general.name }}</h2>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Categoría:</span> -</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Gestión:</span> {{ year }}</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Departamento:</span> {{ general.city }}</h5>
                                    <div class="btn-wrapper mt-4">
                                        <a href="javascript:;" class="btn btn-white btn-border-radius">Ranking Municipal</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center--">
                    <div class="col-lg-12">
                        <div class="">
                            <h3><span class="fa fa-flash"></span> No existen datos para mostrar.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div v-else>
        <section class="section section-shaped section-md my-0 section-header-pages single-region">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="d-flex  align-items-end data-head-single" style="height: 100%;">
                                <div class="flex-column">
                                    <h2 class="display-2 mb-0 text-white">{{ general.name }}</h2>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Categoría:</span> {{ general.population_name }}</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Gestión:</span> {{ this.$route.params.year }}</h5>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Departamento:</span> {{ general.city }}</h5>
                                    <div class="btn-wrapper mt-4">
                                        <a v-on:click="$router.go(-1)" class="btn btn-white btn-border-radius btn-custom-nav">Volver</a>
                                        <!--<a href="javascript:;" class="btn btn-white btn-border-radius">Ranking Municipal</a>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="d-flex justify-content-end data-calification">
                              <div class="wrapper-percent text-center">
                                <div class="counter counter-lg">
                                  <div class="counter-number-group circle" :class="'cal_' + slugify(general.calification_name)">
                                    <span class="counter-number">{{ general.calification | getNumber }}</span>
                                    <span class="counter-number-related">.{{ general.calification | getDecimal }} %</span>
                                  </div>
                                  <div class="counter-label">{{ general.calification_name }}</div>
                                  <div class="counter-label-text">% respecto al total </div>
                                </div>
                              </div>
                            </div>
                        </div>


                        <div class="col-12">
                          <div class="custom-bredcrumbs site-nav-wrap">
                             <nav class="nav">
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.home' }">Inicio IIEG</router-link>
                                  </span>
                                </div>
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.municipalities.national', params: { year: general.year, city: 0 } }">Bolivia</router-link>
                                  </span>
                                </div>
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.municipalities', params: { year: general.year, city: general.city_id, name: slugify(general.city) } }">{{ general.city }}</router-link>
                                  </span>
                                </div>
                               <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <a href="javascript:;">{{ general.name }}</a>
                                  </span>
                                </div>
                            </nav>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="">

                            <h4 class="font-weight-500 mb-4">1. Presupuesto de Inversión</h4>
                            <div>
                              <h5 class="mb-1 mt-2 pl-4">A. En Igualdad y Equidad de Género IIEG </h5>
                            <!--
                              <div class="row row-gridX justify-content-between align-items-center progress-bar-color-orange">
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">Ejecutado</h3>
                                  </div>
                                  <div class="col-lg-6">
                                      <base-progress :value="this.general.percent_iieg" :striped="false" :animated="false" :height="20" type="primary" label="Ejecutado" ></base-progress>
                                  </div>
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.iieg_executed_budget | decimal }} Bs</h3>
                                  </div>
                              </div>
                              <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">Programado</h3>
                                  </div>
                                  <div class="col-lg-6">
                                      <base-progress :value="100" :striped="false" :animated="false" :height="20" type="primary" label="Programado" ></base-progress>
                                  </div>
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.iieg_programmed_budget | decimal }} Bs</h3>
                                  </div>
                              </div>
                            -->
                              <div class="row row-gridX justify-content-between align-items-center progress-bar-color-orange">
                                  <div class="col-md-8 offset-md-2">
                                      <base-progress :value="this.general.percent_iieg" :striped="false" :animated="false" :height="20" type="info" label="% Ejecución" ></base-progress>
                                      <div class="row">
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-left">Programado</h3>
                                        </div>
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.iieg_programmed_budget | decimal }} Bs</h3>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-left">Ejecutado</h3>
                                        </div>
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.iieg_executed_budget | decimal }} Bs</h3>
                                        </div>
                                      </div>
                                  </div>
                              </div>

                            </div>

                            <div class="mt-5">
                              <h5 class="mb-1 mt-2 pl-4">B. Total Menos Deudas</h5>

                              <!--<div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">Ejecutado</h3>
                                  </div>
                                  <div class="col-lg-6">
                                      <base-progress :value="this.general.percent_total" :striped="false" :animated="false" :height="20" type="primary" label="Ejecutado" ></base-progress>
                                  </div>
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.total_executed_budget | decimal }} Bs</h3>
                                  </div>
                              </div>
                              <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">Programado</h3>
                                  </div>
                                  <div class="col-lg-6">
                                      <base-progress :value="100" :striped="false" :animated="false" :height="20" type="primary" label="Programado" ></base-progress>
                                  </div>
                                  <div class="col-lg-3">
                                      <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.total_programmed_budget | decimal }} Bs</h3>
                                  </div>
                              </div>-->

                              <div class="row row-gridX justify-content-between align-items-center progress-bar-color-purple">
                                  <div class="col-md-8 offset-md-2">
                                      <base-progress :value="this.general.percent_total" :striped="false" :animated="false" :height="20" type="info" label="% Ejecución" ></base-progress>
                                      <div class="row">
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-left">Programado</h3>
                                        </div>
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.total_programmed_budget | decimal }} Bs</h3>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-left">Ejecutado</h3>
                                        </div>
                                        <div class="col-md-6">
                                          <h3 class="h6 font-weight-bold mt-4 text-right">{{ general.total_executed_budget | decimal }} Bs</h3>
                                        </div>
                                      </div>
                                  </div>
                              </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="" style="min-height:300px">

                            <h4 class="font-weight-500">2. Composición de la IIEG por Categoría de Análisis</h4>
                            <p>Composición del presupuesto destinado a la promoción de IIEG por categoría de análisis</p>

                            <card shadow body-classes="" class="mt-5">
                                <div class="table-responsive box-table-custom">

                                    <loading :active.sync="isLoading.table" :is-full-page="false" :loader="'dots'" :color="'#ec1c8d'" :opacity="1" ></loading>

                                    <table class="table table-striped table-bordered1">
                                      <thead>
                                        <tr>
                                          <th scope="col" class="text-center">Categoría de Análisis</th>
                                          <th scope="col" class="text-center">Denominación</th>
                                          <th scope="col" class="text-center">Monto Ejecutado</th>
                                          <th scope="col" class="text-center">% ejecución respecto al total inversión ejecutada</th>
                                        </tr>
                                      </thead>
                                      <tbody>

                                        <tr v-for="(item1, index) in tables.globalIIEG.data">
                                          <th scope="row" >{{ item1.name }}</th>
                                          <td class="">{{ item1.description }}</td>
                                          <td class="text-right">{{ item1.value | decimal }}</td>
                                          <td class="text-right">{{ item1.percent }} %</td>
                                        </tr>

                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <th scope="col" >{{ tables.globalIIEG.totals.name }}</th>
                                              <th scope="col" class=""></th>
                                              <th scope="col" class="text-right">{{ tables.globalIIEG.totals.value | decimal }}</th>
                                              <th scope="col" class="text-right">{{ tables.globalIIEG.totals.percent }} %</th>
                                          </tr>
                                      </tfoot>
                                    </table>

                                </div>
                            </card>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="">

                            <loading :active.sync="isLoading.chart" :is-full-page="false" :loader="'dots'" :color="'#51c3c8'"></loading>

                            <h4 class="font-weight-500">3. Comparación de la IIEG entre Gestiones</h4>
                            <p>Comparación del presupuesto ejecutado en IIEG entre gestiones</p>

                            <div class="custom-chart-container" ref="chart"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
const axios = require('axios');

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "region",
  data() {
    return {
      have_data: true,

      //spinner load
       isLoading: {
            chart : false,
            table : false
      },

      //charts instances
      charts: {},

      //tables data
      tables: {
        globalIIEG: { data: '', totals: '' }
      },

      //data general
      general: '',
      year: '',
      region: '',
      type: '',

      perc: 3
    }
  },
  components: {
    Loading
  },
  filters: {
    getNumber(n){
        return ((""+n).split('.'))[0];
    },
    getDecimal(n){
        return ((""+n).split('.'))[1];
    },
    decimal(num) {
        var nStr = parseFloat(num).toFixed(0);
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },

  },
  methods: {
    getGeneralData(){

      let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipality/${this.$route.params.code}/generalData`;

      axios.get(uri).then((response) => {
          if(response.data.success){
              this.general = response.data.result;
              this.year = response.data.year;
              this.region = response.data.region;
          } else {
              if(response.data.having_data == false) {
                  this.have_data = false;
                  this.general = response.data.result;
                  this.year = response.data.year;
                  this.region = response.data.region;
              } else {
                  this.$router.push({name: 'error404'});
              }
          }
      }).catch((response) => {
          console.log(response)
      }).finally(() => {

      });
    },
    getAsyncChartsTables() {
      this.tableGlobalIIEG();
      this.chartBarComparative();
    },
    async tableGlobalIIEG() {
      this.isLoading.table = true;
      let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipality/${this.$route.params.code}/tableGlobalIIEG`;
      await axios.get(uri).then((response) => {
          if(response.data.success) {
              this.tables.globalIIEG.data = response.data.data;
              this.tables.globalIIEG.totals = response.data.totals[0];
          } else { console.log(response.data); }
      }).catch((response) => {
          console.log(response)
      }).finally(() => {
          this.isLoading.table = false;
      });
    },
    async chartBarComparative() {
        this.isLoading.chart = true;
        let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipality/${this.$route.params.code}/chartComparativeYears`;
        await axios.get(uri).then((response) => {
            if(response.data.success) {
                this.renderChartBarComparative(response.data.chart);
            } else { console.log(response.data); }
        }).catch((response) => {
            console.log(response)
        }).finally(() => {
            this.isLoading.chart = false;
        });
    },
    renderChartBarComparative(data) {

        var maxv = this.getMaxValueChartBar(data);

        var vm = this;
        let chart = am4core.create(this.$refs.chart, am4charts.XYChart);
        //chart.paddingTop = 50;
        chart.data = data;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 30;
        //categoryAxis.renderer.inside = true;
        //categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
        categoryAxis.renderer.labels.template.fontSize = 20;

        var  valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeDasharray = "4,4";
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.max = maxv;
        valueAxis.min = 0;
        valueAxis.strictMinMax = true;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "investment";
        series.dataFields.categoryX = "year";
        series.name = "Porcentaje";
        series.clustered = false;
        //series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;

        var columnTemplate = series.columns.template;
        columnTemplate.width = 120;
        columnTemplate.column.cornerRadiusTopLeft = 5;
        columnTemplate.column.cornerRadiusTopRight = 5;
        columnTemplate.column.cornerRadiusBottomLeft = 5;
        columnTemplate.column.cornerRadiusBottomRight = 5;
        columnTemplate.adapter.add("fill", function (fill, target) {
            return am4core.color("#cc8b00");
        });
        columnTemplate.strokeOpacity = 0;
        //columnTemplate.propertyFields.fill = am4core.color("#a8b3b7");
        //columnTemplate.propertyFields.stroke = "color";

        var txtLabel = series.bullets.push(new am4charts.LabelBullet());
        txtLabel.label.text = "{valueY} %";

        //txtLabel.locationY = 0.5;
        //txtLabel.label.verticalCenter = "top";
        txtLabel.label.fill = am4core.color("#000000");

        txtLabel.label.hideOversized = false;
        txtLabel.label.truncate = false;
        txtLabel.label.horizontalCenter = "middle";
        txtLabel.dy = -15;

        this.charts.chart = chart;
    },
    getMaxValueChartBar(data) {
        let vt = 0;
        var tmp = data;
        tmp.forEach( function(valor, indice, array) {
          if(valor.investment > vt){
            vt = valor.investment;
          }
        });
        let ca = parseInt(vt).toString().length;
        if (ca == 1) {
          vt = vt + 1;
        } else if (ca == 2) {
          vt = vt + 10;
        }
        return vt;
    },
    slugify(text) {
      var char = '' + text;
      return char.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    }
  },
  mounted() {
    this.getGeneralData();
    this.getAsyncChartsTables();
  },
  beforeDestroy() {
    if (this.charts.chart) {
      this.charts.chart.dispose();
    }
  }
};
</script>

<style scoped>

.chartwrapper {
  position: relative;
  width: 100%;
  height: 400px;

  border: 1px solid #111;

}
.chartdiv {
  position: absolute;
  top: -30px;

  width : 100%;
  height : 450px;

  border: 1px solid #bbb;
}

.custom-chart-container {
  width: 100%;
  height: 400px;
}
</style>